// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2C4w6","inputWrap":"styles_inputWrap__cfVT9","input":"styles_input__ZxGGJ"};